<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Basic Form</h4>
            </li>
            <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Forms</a>
            </li>
            <li class="breadcrumb-item active">Basic</li>
          </ul>
        </div>
      </div>
    </div>
    <app-maser-page-header></app-maser-page-header>
    <div class="row">
      <div class="col-6">
        <button mat-fab color="primary" (click)="registerLocationCategory()" style="float: right">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
        </button>
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
            <td mat-cell *matCellDef="let element;let i =index"> {{i+1}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.name}}
                </div>
                <div class="col">
                  <mat-icon (click)="editLocationCategory(element)">edit</mat-icon>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div class="col-5" *ngIf="this.locationCategoryService.is_display_location_category_register_component">
        <div class="row">
          <div class="col"></div>
          <div class="col-1">
            <button mat-fab color="primary" (click)="hideLocationCategoryRegister()">
              <i class="material-icons">
                clear
              </i>
            </button>
          </div>
        </div>
        <app-location-category-register></app-location-category-register>
      </div>
    </div>
  </div>
</section>
